/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SignupForm from './SignupForm';

import { SIGNUP_ACTIVE, SIGNUP_COMPLETED } from '../../../constants';
import PropTypes from 'prop-types';
import { setSignupActive } from '../../../Actions';
import EmailSent from './EmailSent';

class SignupPage extends Component {
  componentDidMount() {
    this.props.setSignupActive();
  }

  render() {
    return (
      <div className={'register-page'}>
        {this.props.signup_status === SIGNUP_ACTIVE && (
          <SignupForm {...this.props} />
        )}
        {this.props.signup_status === SIGNUP_COMPLETED && <EmailSent />}
      </div>
    );
  }
}

SignupPage.propTypes = {
  signup_status: PropTypes.string,
  setSignupActive: PropTypes.func,
};

const mapStateToProps = (state) => ({
  signup_status: state.signup.signup_status,
});

export default connect(mapStateToProps, {
  setSignupActive: setSignupActive,
})(SignupPage);
